<template>
    <div style="border: 1px solid #ccc;" :style="{ width: attrs.width}">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editorRef"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            class="wangeditor"
            :style="{ height: attrs.height }"
            v-model="valueHtml"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="handleCreated"
        />
        <upload ref="uploadRef" dir="images" v-model="files" v-model:checkedData="files_path" button="上传单张图片" :is-ueditor="true" :is-multiple="true" />
    </div>
</template>

<script>
    import { getCurrentInstance, defineComponent, ref, watch, onBeforeUnmount, shallowRef, onMounted } from 'vue'
    import Upload from '@/components/ui-upload'
    import Utils from '@/utils/util'
    import '@wangeditor/editor/dist/css/style.css' // 引入 css
    import { Editor, Toolbar, IEditorConfig } from '@wangeditor/editor-for-vue'

    export default defineComponent({
        components: {
            Upload,
            Editor,
            Toolbar
        },
        props: {
            attr: {
                type: [Array, Object],
                default: () => { }
            },
            modelValue: {
                type: [Number, String],
                default: ''
            }
        },
        setup(props, context) {
            const attrs = ref({
                width: props.width,
                height: props.height
            })
            const files = ref()
            const files_path = ref()
            // 编辑器实例，必须用 shallowRef
            const editorRef = shallowRef()
            const uploadRef = ref()
            const uploadvideosRef = ref()
            const valueHtml = ref(props.modelValue)
            const file_type = ref()
            const insertImags = ref()
            const insertVideo = ref()
            const toolbarConfig = {
                excludeKeys: ['group-video']
            }
            const editorConfig = {
                placeholder: '请输入内容...',
                MENU_CONF: {
                    uploadImage: {
                        customBrowseAndUpload(insertFn) {
                            file_type.value = 'image'
                            uploadRef.value.upButton()
                            insertImags.value = insertFn
                        }
                    },
                    uploadVideo: {
                        customBrowseAndUpload(insertFn) {
                            file_type.value = 'video'
                            uploadRef.value.upButton()
                            insertVideo.value = insertFn
                        }
                    }
                }
            }
            // 组件销毁时，也及时销毁编辑器
            onBeforeUnmount(() => {
                const editor = editorRef.value
                if (editor == null) return
                editor.destroy()
            })

            const handleCreated = (editor) => {
                editorRef.value = editor
            }
            return {
                editorRef,
                valueHtml,
                mode: 'default',
                toolbarConfig,
                editorConfig,
                handleCreated,
                insertImags,
                insertVideo,
                file_type,
                uploadRef,
                files,
                files_path,
                attrs
            }
        },
        watch: {
            valueHtml(newv, oldv) {
                this.$emit('update:modelValue', newv)
            },
            files(newv, oldv) {
                if (newv !== '') {
                    let files = this.files_path.split(',')
                    files.forEach((item, index) => {
                        if (this.file_type === 'image') {
                            this.insertImags(Utils.getImgUrl(item))
                        }
                        if (this.file_type === 'video') {
                            this.insertVideo(Utils.getImgUrl(item))
                        }
                    })
                    this.files_path = ''
                    this.files = ''
                }
            }
        },
        methods: {
        }
    })
</script>

<style >
    .wangeditor {
        height: 400px;
        overflow-y: hidden;
    }
    .w-e-full-screen-container{
        z-index: 3;
    }
</style>
